import React from "react";
import Button from "../Button";

const MobileMenu = ({closeHandler, displayShopsHandler}) => {
    return (
        <div className="mobile-menu">

            <Button classnames="btn ellipse-fa" handler={()=>{
                const shareUrl = `${process.env.REACT_APP_FACEBOOK_SHARE_URL}${encodeURIComponent(document.location)}`;
                window.open(
                    shareUrl,
                    'facebook-share-dialog',
                    'width=626,height=436');
            }}>
                <i className="fa fa-facebook" />
            </Button>

            <Button classnames="btn ellipse-fa" href={process.env.REACT_APP_INSTAGRAM_URL} handler={()=>{}}>
                <i className="fa fa-instagram" />
            </Button>

            <Button classnames="btn ellipse-mini close icon-close-blue" handler={()=>{
                closeHandler();
            }}></Button>
        </div>
    );
}

export default MobileMenu;